import { useTranslation } from 'react-i18next'

import { OfferStatus } from '@wwt/entities/api/search-response'
import { statusColorsAsCSSVariables } from '@wwt/shared/config/statusColors'

import { HELP_EMAIL } from '@/shared/config/HELP_EMAIL'
import { cn } from '@/shared/lib/cn'

import { Button } from '../Button'
import { OfferStatusBadge } from './OfferStatusBadge'

interface OfferDescribedStatusProps {
	status: keyof typeof OfferStatus
	message?: string
	className?: string
}

const SHOW_REFRESH_PAGE = [
	OfferStatus.RESERVATION_PENDING,
	OfferStatus.RESERVATION_CANCEL_PENDING
] as const

const SHOW_SUPPORT = [OfferStatus.RESERVATION_CANCEL_FAILED] as const

export const OfferDescribedStatus = ({
	status,
	message,
	className
}: OfferDescribedStatusProps) => {
	const { t } = useTranslation('translation')

	if (status === OfferStatus.RESERVED) return null

	const handleRefreshPage = () => {
		location.reload()
	}

	const statusMessage = message ?? t(`statusesReasons.${status}`)

	return (
		<div
			className={cn(
				'flex flex-col gap-4 rounded-md border border-(--background) p-4 md:flex-row lg:flex-col xl:flex-row',
				className
			)}
			style={
				{
					'--background': `var(${statusColorsAsCSSVariables[status]})`
				} as React.CSSProperties
			}
		>
			<OfferStatusBadge
				className="px-5 text-nowrap max-md:mx-0 lg:mb-0"
				status={status}
			/>

			<span>{statusMessage}</span>

			{SHOW_REFRESH_PAGE.includes(status) && (
				<Button
					size="sm"
					onClick={handleRefreshPage}
					variant="outline"
				>
					{t('refreshPage')}
				</Button>
			)}

			{SHOW_SUPPORT.includes(status) && (
				<Button
					asChild
					size="sm"
					variant="outline"
				>
					<a href={`mailto:${HELP_EMAIL}`}>{t('support')}</a>
				</Button>
			)}
		</div>
	)
}
